<main>
  <div class="container-fluid">
    <h1 class="mt-4">Merchant Group</h1>
    <ol class="breadcrumb mb-4">
      <li class="breadcrumb-item active">Merchant Group</li>
    </ol>

    <div class="row">
      <div class="col">
        <button class="btn btn-primary" (click)="openAddModal()">Add Merchant Group</button>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-4 ml-auto">
        <input class="form-control" [(ngModel)]="searchTerm" placeholder="Search by name" />
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Order Sheet ID</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of filteredMerchantGroups">
              <td>{{ g.name }}</td>
              <td>{{ g.orderSheetId || '-' }}</td>
              <td>
                <button class="btn btn-sm btn-primary" (click)="openEditModal(g)">
                  <i class="fas fa-edit"></i> Edit
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <ng-template #groupModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{ isEdit ? 'Edit' : 'Add' }} Merchant Group</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="isTeamLeaderOnly; else normalNameBlock">
        <div class="form-group">
          <label>Team name</label>
          <input class="form-control" [value]="teamName" readonly />
        </div>
        <div class="form-group">
          <label>Group name</label>
          <input class="form-control" [(ngModel)]="groupDetail.name" placeholder="Group name" />
        </div>
      </div>
      <ng-template #normalNameBlock>
        <div class="form-group">
          <label>Name</label>
          <input class="form-control" [(ngModel)]="groupDetail.name" placeholder="Group name" />
        </div>
      </ng-template>
      <div class="form-group">
        <label>Order Sheet ID</label>
        <input class="form-control" [(ngModel)]="groupDetail.orderSheetId" placeholder="Order sheet ID (optional)" />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="saveGroup()">Save</button>
    </div>
  </ng-template>
</main>
